export default __webpack_public_path__ + "static/media/tyger.ab3dd834.png";